// ConceptOmission — Sprint 19BH Day 1 Step 1.2 · soft escape for K18.
//
// Why this exists (v4-rewrite.md K18 + §13 audit framework):
//   F37 (19BG+3 Phase B) measured a regression where schema floors (e.g.
//   essay min=2 + freeResp min=2 + proofDrill min=2) compounded into a
//   target the LLM couldn't reach for chapters with thin source coverage.
//   The old failure mode was hard reject + retry storm. v4 lets the LLM
//   self-report "I could not cover concept X in stage Y because <reason>"
//   via an `omittedConcepts: ConceptOmission[]` field that ALL item schemas
//   carry as optional.
//
//   Audit (Day 3) post-processes these into GapEntry items with severity
//   'warn' (vs the hard 'error' for unexplained missing coverage). The user
//   sees the gap in the regen UI with the LLM's reason as context, and can
//   one-click `fill_audit_gap` to trigger a targeted regen with extra
//   source context.
//
// Why bounded `reason` (1–200 chars):
//   - 1 char minimum forces the LLM to actually write something (empty
//     reason would defeat the soft-escape purpose).
//   - 200 char ceiling keeps the omission record cheap to ship to the
//     audit ctx in regen-with-hint payloads (Day 4 regen workflow).
import { z } from 'zod';
import { OUTLINE_ID_PATTERN, OUTLINE_ID_MESSAGE } from './curriculum-outline.js';
import { StageIdSchema } from './stage-id.js';
export const ConceptOmissionSchema = z.object({
    /** The concept id the LLM could not cover. Must be a real outline concept. */
    conceptId: z.string().regex(OUTLINE_ID_PATTERN, OUTLINE_ID_MESSAGE)
        .describe('Concept id from the outline that this stage could not cover.'),
    /** Human-readable reason. Becomes the GapEntry.message in the audit report. */
    reason: z.string().min(1).max(200)
        .describe('1–200 chars. Why this concept was omitted. Surfaced in audit GapEntry and regen-with-hint prompts.'),
    /** Stage that emitted this omission. Used by audit to scope regen context. */
    stage: StageIdSchema
        .describe('Stage id that omitted this concept (e.g. mcqs, lecture_notes).'),
}).passthrough();
//# sourceMappingURL=concept-omission.js.map